import ReactDOM from 'react-dom';
import SpecTheme from '../../style/spec-theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Questionnaire from './Questionnaire';
import Branding from '../../components/decor/Branding';
import { waitForWindowLoadComplete } from 'Utils/waitForWindowLoadComplete';

const start = () => {
  const { orgId, orgName, questionnaire, branding, embedded } =
    window.INITIAL_DATA;

  // mixpanel.track('Questionnaire shown', {
  //   orgId,
  //   orgName
  // })

  ReactDOM.render(
    <MuiThemeProvider theme={SpecTheme}>
      {!embedded && (
        <div style={{ margin: '16px auto', textAlign: 'center' }}>
          <Branding branding={branding} maxHeight={160} maxWidth={240} />
        </div>
      )}
      <Questionnaire questionnaire={questionnaire} />
    </MuiThemeProvider>,
    document.getElementById('app'),
  );
};
waitForWindowLoadComplete(start);
